import styled, { css } from "styled-components";

import { rem } from "@ui/helpers";
import { InfoLabel } from "@ui/Atoms/InfoLabel";

const Container = styled.div<{ minHeight?: number }>`
  padding: ${({ theme }) => `${theme.margins.base_x3} 0`};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.margins.base_x4};

  ${({ minHeight }) => css`
    min-height: ${`${minHeight ?? 0}px`};
  `}

  ${props => props.theme.breakpoints.tablet} {
    padding: ${({ theme }) =>
      `${theme.margins.base_x3} ${theme.margins.base_x4}`};
  }
`;

const TextIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.margins.base_x2};
`;

const Text = styled.div`
  font-size: ${props => props.theme.fonts.sizes.body};
  font-weight: ${props => props.theme.fonts.weights.semibold};
  text-align: center;

  ${props => props.theme.breakpoints.tablet} {
    max-width: ${rem(460)};
  }
`;

const Info = styled(InfoLabel).attrs({
  variant: "info",
})`
  padding: ${props => props.theme.margins.base_x2};
  font-size: ${props => props.theme.fonts.sizes.body2};
  text-align: center;
  color: ${props => props.theme.palette.grey800};
  color: currentColor;
  border-radius: ${props => props.theme.border.radius.base};

  ${props => props.theme.breakpoints.tablet} {
    max-width: ${rem(460)};
  }
`;

export { Container, TextIconContainer, Text, Info };
